function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 30,
    viewBox: "0 0 400 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.1,9.8l-2.7.7c-1.1-3.2-3.4-4.9-6.7-5-4.8.4-7.3,3.5-7.6,9.4.3,5.9,2.8,9.1,7.6,9.5,3.9,0,6.3-2.1,7.2-6.2l2.7.8c-1.2,5-4.5,7.6-9.8,7.7-6.6-.4-10-4.3-10.4-11.6.4-7.5,3.9-11.4,10.6-11.8,4.4,0,7.5,2.3,9.1,6.5Z",
    style: {
      fill: "#024dc4",
      stroke: "#024dc4",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,9.8l-2.7.7c-1.1-3.2-3.4-4.9-6.7-5-4.8.4-7.3,3.5-7.7,9.4.3,5.9,2.8,9.1,7.6,9.5,3.9,0,6.3-2.1,7.2-6.2l2.7.8c-1.2,5-4.5,7.6-9.8,7.7-6.6-.4-10-4.3-10.4-11.6.4-7.5,3.9-11.4,10.6-11.8,4.4,0,7.5,2.3,9.2,6.5Z",
    style: {
      fill: "#024dc4",
      stroke: "#024dc4",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,17.3h-6.8v9h-2.6V3.6h9.6c4.9.2,7.5,2.5,7.8,6.7,0,4.5-2.7,6.9-8,7ZM102.9,5.7h-6.3v9.4h6.3c3.8,0,5.7-1.7,5.8-4.9-.2-2.9-2.1-4.4-5.8-4.5Z",
    style: {
      fill: "#024dc4",
      stroke: "#024dc4",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,26.2h-7.9V3.5h7.9c7.2.2,10.8,3.9,11,11.2.2,7.9-3.5,11.7-11,11.5ZM125.6,5.7h-5.2v18.4h5.1c5.7,0,8.5-3.1,8.5-9.3-.1-5.9-2.9-8.9-8.4-9.1Z",
    style: {
      fill: "#024dc4",
      stroke: "#024dc4",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,15.9h-15.3v-1.9h15.4v1.9h0Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,13.9c-.6-3.1-1.2-5.3-1.5-6.7l1.5-.4c.6,2.6,1.2,4.8,1.6,6.7l-1.6.4ZM179.4,13.4l-1.2-.9v.6c-.1,1.7-.2,3-.3,3.8,1.2,1.5,2.6,3.2,4.2,5.1l-1.4,1.6c-.3-.5-.8-1.1-1.4-2-.7-1.1-1.3-1.9-1.7-2.4-.5,2.9-1.7,5.9-3.7,8.9-.1-.1-.2-.2-.4-.4-.5-.6-.9-1-1.2-1.2,2.5-3.5,3.8-8,3.9-13.4.1-2.7.1-6.5.1-11.6h2c0,4.5-.1,8-.2,10.7,1.1-2.5,1.9-4.3,2.3-5.7l1.5,1c-.4,1-1.1,2.6-2.2,5-.1.5-.2.8-.3.9ZM191.4,15.2v2.8h8v1.8h-6.8c1.8,2.4,4.2,4.2,7.2,5.4-.4.6-.8,1.2-1.2,1.9-3.3-1.7-5.8-3.8-7.3-6.2v7.5h-2v-7.5c-1.9,2.6-4.4,4.8-7.7,6.6-.5-.8-.9-1.4-1.2-1.8,3.2-1.6,5.7-3.5,7.7-5.9h-6.5v-1.8h7.8v-2.8h-5.2V6.4h-2.6v-1.9h2.6V1.6h2v2.9h8.4V1.6h2v2.9h2.7v1.8h-2.7v8.9h-5.2ZM186.1,6.4v2.7h8.4v-2.7h-8.4ZM186.1,10.8v2.7h8.4v-2.7h-8.4Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,17.5c-.1-.3-.3-.7-.5-1.3-.2-.6-.4-1.1-.5-1.3,3.1-3.6,5.5-8,7.5-13.1l2.3.7c-1.1,2.6-2.2,4.9-3.3,6.8v19h-2.2v-15.3c-1.1,1.5-2.1,3-3.3,4.5ZM210,20.3c-.2-.3-.6-.9-1.2-1.8-.1-.1-.2-.2-.2-.3,2.4-1.2,4.6-2.4,6.5-3.6V2h2.4v10.9c2.9-2.2,5.4-4.7,7.7-7.6l1.9,1.5c-2.8,3.4-6,6.4-9.6,9v7.2c-.1,1.6.7,2.4,2.4,2.3h2.6c1.6,0,2.5-.6,2.7-1.9.2-1,.4-2.5.6-4.7,1,.4,1.8.6,2.3.8-.2,1.8-.4,3.5-.7,4.9-.3,2.1-1.9,3.1-4.7,3.1h-3.5c-2.9.1-4.2-1.3-4.1-4.2v-5.8c-1.6.9-3.3,1.9-5.1,2.8Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,6.1v-2.2h23.3v2.3h-10.4v18h12v2.3h-26.4v-2.3h11.9V6.2h-10.4Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6,13.9c-.6-.3-1.1-.5-1.6-.7.9-2.5,1.5-5.5,1.7-9.1l1.7.2c-.2,1.4-.3,2.6-.5,3.6h2.4V1.5h2.1v6.4h2.6v2h-2.6v5.8c.9-.2,1.8-.5,2.6-.8,0,.7,0,1.4.1,2.1-.9.2-1.8.5-2.8.9v10.4h-1.9v-9.8l-4.8,1.6-.3-2.3,5.2-1.5v-6.4h-2.7c-.4,1.3-.8,2.6-1.2,4ZM269,12.9c-.3-.2-.6-.5-1.1-.9-.2-.2-.4-.4-.6-.5,2.1-2.9,3.8-6.3,4.9-10l2.1.5c-.4,1.2-1,2.5-1.5,3.8h11.5c-.2,6.9-.4,12.6-.5,16.9,0,3.2-1.5,4.8-4.5,4.8s-2.5.1-3.6.1c-.2-1-.4-1.8-.5-2.3,1.3.1,2.5.1,3.6.1,1.9.1,2.8-.9,2.9-3.1.2-4,.4-8.8.5-14.5h-2.1c-.5,9.3-3.6,15.9-9.4,19.8-.6-.6-1.1-1.2-1.7-1.7,5.7-3.8,8.8-9.9,9.3-18.2h-2.4c-.8,6-3.2,10.8-7.2,14.3-.6-.6-1.2-1.2-1.7-1.6,3.9-3.3,6.3-7.5,7.2-12.7h-2.2c-1.1,2.2-2.1,3.8-3,5.2Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,14.9c-.5-.1-1.1-.2-1.7-.3.4-2.1.8-4.4,1.1-7l1.7.2c-.2,1.5-.5,3.9-1.1,7.1ZM295.2,10.7c-.7-.9-1.5-1.8-2.3-2.7v20.3h-2.2V1.5h2.2v5.3l.7-.8c1,1,2,2.1,2.9,3.1l-1.3,1.6ZM297.6,14.1c-.6-.3-1.3-.6-2-.9,1.6-2.9,2.7-6.2,3.4-9.8l2.1.4c-.3,1.3-.6,2.5-1,3.7h3.8V1.5h2.3v6h6.8v2.1h-6.8v6.4h6.4v2.1h-6.4v7h7.6v2.1h-18.4v-2.2h8.6v-7h-6.9v-2h6.9v-6.4h-4.5c-.5,1.5-1.1,3-1.9,4.5Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,28.4c-.2-.5-.5-1.1-1-1.9,3.1-.7,5.4-1.5,7-2.5-1.6-.7-3.3-1.5-5.2-2.4l1.8-2.6h-3.3v-1.8h4.4c.4-.7.8-1.3,1.1-1.9l2.1.3c-.1.1-.2.3-.4.6-.3.4-.5.8-.6,1h6.5v1.8c-.5,1.8-1.4,3.3-2.7,4.5l3,1.3-1.2,1.8-3.5-1.7c-2,1.4-4.7,2.6-8,3.5ZM316,9.5v-1.8h6.3V1.7h2v6h5.6v1.8h-5.6v2.4l.9-1c1.5.9,2.9,1.7,4.3,2.7l-1.1,1.6c-.5-.4-1.8-1.3-4-2.8v2.5h-2v-3.5c-1.4,1.7-3.3,3.1-5.6,4.3-.3-.5-.6-1.1-1.1-1.7,2.5-1,4.6-2.5,6.2-4.3h-5.9v-.2ZM319.6,7.1c-.6-.7-1.6-1.8-3-3.3l1.3-1.1c1.6,1.5,2.7,2.6,3.2,3.2l-1.5,1.2ZM319.9,20.9c1.4.6,2.9,1.2,4.3,1.8,1.2-1,2-2.3,2.5-3.7h-5.5c-.5.7-.9,1.4-1.3,1.9ZM326.7,7.1l-1.4-1.2c.8-.7,1.9-1.8,3.2-3.2l1.5,1.1c-1.4,1.4-2.5,2.5-3.3,3.3ZM330.3,14.4c-.5-.7-1-1.3-1.4-1.7,2.1-3.3,3.7-7.1,4.8-11.5l2.1.3c-.4,1.6-.9,3.2-1.5,4.6h8v2.1h-2.1c-.5,5.6-1.7,9.9-3.3,12.7,1.3,1.7,3.1,3.5,5.6,5.1-.1.1-.2.3-.4.5-.5.6-.8,1.1-1,1.5-2.4-1.8-4.3-3.6-5.5-5.2-1.4,1.8-3.3,3.6-5.8,5.5-.2-.4-.7-1-1.5-1.8,2.8-2,4.8-3.9,6-5.6-1.3-2.3-2.2-5.2-2.7-8.8-.4.9-.8,1.6-1.3,2.3ZM333.1,9.3c.5,4.3,1.3,7.5,2.5,9.8,1.3-2.4,2.1-5.9,2.5-10.7h-4.7c0,.2-.1.5-.3.9Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4,8.9v-2h3.1V1.6h2.1v5.2h2.7v2h-2.7v5.8l2.6-.7c0,.7,0,1.4.1,2.1-.1,0-.2,0-.3.1-1,.3-1.7.5-2.3.7v8c.1,2.1-.8,3.1-2.8,3.2-1.2,0-2,.1-2.3.1,0-.6-.2-1.4-.3-2.3.4,0,1.1.1,1.9.1,1,.1,1.5-.4,1.5-1.4v-7.1c-.4.1-1.1.3-2,.6-.6.2-1,.3-1.2.4l-.2-2.3c1.1-.2,2.3-.5,3.5-.9v-6.3h-3.4ZM352,28.2c-.7-.6-1.3-1.1-1.7-1.5,1.3-1.9,2.2-3.9,2.7-5.9s.7-4.8.7-8.4V3h16.3v7.3h-14.2v3.3h6.4v-2.8h2.1v2.8h7v1.9h-7v3.3h5.5v9.4h-2.1v-1.5h-8.9v1.5h-2.1v-9.4h5.4v-3.3h-6.4c0,5.1-1.4,9.3-3.7,12.7ZM355.7,4.8v3.6h12.1v-3.6h-12.1ZM358.7,20.6v4.2h8.9v-4.2s-8.9,0-8.9,0Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,28.4c-.7-.6-1.3-1.1-1.8-1.5,1.1-1.9,1.9-3.7,2.2-5.4.4-1.6.5-4.2.5-7.8V4.4h11.4c-.1-.5-.3-1.3-.6-2.3-.1-.2-.1-.3-.1-.4l2.5-.3.7,3h10.2v1.9h-22v7.7c0,3.6-.2,6.4-.6,8.4-.4,1.9-1.2,3.9-2.4,6ZM379.1,11.9v-1.9h5.7c.6-1,1.2-1.9,1.7-2.9l2.4.3c-.5.9-1,1.7-1.6,2.5h11v1.9h-12.3c-1.1,1.7-2.2,3.2-3.3,4.7h5.9v-3.3h2.2v3.3h7.4v1.9h-7.4v3.1h8.7v1.9h-8.7v4.9h-2.2v-4.9h-10.5v-1.9h10.5v-3.1h-8.4v-2.1c1.3-1.7,2.4-3.2,3.3-4.5h-4.4Z",
    style: {
      fill: "#465566",
      stroke: "#465566",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,6.9l-2.9-4.7c-.7-1.1-1.8-1.7-3.1-1.7H6.7c-1.3,0-2.5.7-3.1,1.7L.7,6.9h28.4Z",
    style: {
      fill: "#024dc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4,8.3v17.6c0,2,1.6,3.6,3.6,3.6h21.8c2,0,3.6-1.6,3.6-3.6V8.3H.4ZM23.1,23.1h0c-1.8,0-3.3-1.5-3.3-3.3s.1-.7.2-1l-2.5-1.5c-.4.3-.9.6-1.5.6s-.3,0-.5-.1h0l-2.9,4.8c-.1.2-.3.3-.5.3h-.1c-.2,0-.3-.1-.5-.2l-4-3.2c-.4.3-.9.4-1.5.4-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7-.1.8-.3,1.1l3.3,2.7,2.5-4.1c-.3-.4-.5-.9-.5-1.4,0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v.4l2.6,1.5c.6-.6,1.4-1,2.4-1,1.8,0,3.3,1.5,3.3,3.3,0,1.9-1.4,3.4-3.3,3.4Z",
    style: {
      fill: "#40454c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.c69eece380287fe690c5e93635646df3.svg";
export { ForwardRef as ReactComponent };